import type { UserProfileData } from '../model';

export interface HeaderUserProfileProps {
	user: UserProfileData;
}

export function HeaderUserProfile({ user }: HeaderUserProfileProps) {
	const handleClick = () => {
		console.log('User profile clicked');
	};

	return (
		<button
			onClick={handleClick}
			className="flex items-center gap-2 md:gap-4 px-2 py-2 md:px-4 bg-brand-page-bg border border-brand-navy rounded-lg hover:bg-opacity-80 transition-colors"
		>
			{/* Avatar */}
			<div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-brand-navy bg-white flex items-center justify-center flex-shrink-0 overflow-hidden">
				{user.avatarUrl ? (
					<img src={user.avatarUrl} alt={user.name} className="w-full h-full object-cover" />
				) : (
					<span className="text-brand-navy font-semibold text-sm">{user.initials}</span>
				)}
			</div>

			{/* User Info — hidden on mobile */}
			<div className="hidden md:flex flex-col items-start text-left">
				<p className="text-sm font-semibold text-brand-navy leading-5">{user.name}</p>
				<p className="text-xs text-gray-600 leading-4">{user.role}</p>
			</div>
		</button>
	);
}
